import createIcon from '../../createIcon';

/**
 * @component @name AirplanemodeActive
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgMTZWMTRMMTMuNSA5VjMuNUMxMy41IDIuNjcgMTIuODMgMiAxMiAyQzExLjE3IDIgMTAuNSAyLjY3IDEwLjUgMy41VjlMMiAxNFYxNkwxMC41IDEzLjVWMTlMOCAyMC41VjIyTDEyIDIxTDE2IDIyVjIwLjVMMTMuNSAxOVYxMy41TDIyIDE2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AirplanemodeActive = createIcon('AirplanemodeActive', [
  [
    'path',
    {
      d: 'M22 16V14L13.5 9V3.5C13.5 2.67 12.83 2 12 2C11.17 2 10.5 2.67 10.5 3.5V9L2 14V16L10.5 13.5V19L8 20.5V22L12 21L16 22V20.5L13.5 19V13.5L22 16Z',
      key: 'qhluat',
    },
  ],
]);

export default AirplanemodeActive;
